import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import Laoder from "../../../../../../modules/pages/newLetter/Loader";
import { getRequestByAuth } from "../../../../../../function/helper";
import NewAddress from "../../../../../../modules/components/addresses/NewAddress";
import style from "./GetterAddressModal.module.css";

function GetterAddressModal({ set, close }) {
  const [isLoading, setIsLoading] = useState(false);
  const [key, setKey] = useState("");
  const didMount = useRef(false);
  const [listAddressSender, setListAddressSender] = useState([]);

  const [showNewAddressModal, setShowNewAddressModal] = useState(false);

  useEffect(() => {
    if (didMount.current) {
      if (key.length < 3) return;
      const timeoutId = setTimeout(() => {
        getAddress();
      }, 1500);

      return () => clearTimeout(timeoutId);
    } else didMount.current = true;
  }, [key]);

  const getAddress = async () => {
    setIsLoading(true);
    setListAddressSender([]);

    const response = await getRequestByAuth("/address/v1/search/1/" + key);
    setIsLoading(false);

    if (response.status !== 401) {
      setListAddressSender(response.data);
    }
  };

  return (
    <Fragment>
      <Modal
        show={true}
        direction="rtl"
        size="lg"
        centered={true}
        className={style.modal}
      >
        <Modal.Header className="d-flex align-item-center justify-content-center">
          <Modal.Title>جستجو از آدرس های گیرنده قبلی</Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="d-flex align-item-center justify-content-center text-right "
          style={{ textAlign: "right", direction: "rtl" }}
        >
          <div className="w-100">
            <div>
              <Row className="mt-2">
                <Col lg={12} md={12} sm={12}>
                  <Form.Label>
                    جستجوی آدرس (حداقل چهار کاراکتر الزامی است)
                  </Form.Label>
                  <Form.Control
                    type="text"
                    autoFocus
                    onChange={e => setKey(e.target.value)}
                  ></Form.Control>
                  {isLoading && (
                    <div>
                      <Laoder />
                    </div>
                  )}
                  {listAddressSender.map((item, idx) => (
                    <button
                      className="btn btn-light m-1 w-100"
                      onClick={() => set(item)}
                      key={idx}
                    >
                      {item.address.country_name.faName} -{" "}
                      {item.address.province_name.faName} -{" "}
                      {item.address.city_name.faName} -{" "}
                      {item.address.totalAddress} - {item.address.compony} -{" "}
                      {item.address.phone}
                    </button>
                  ))}
                </Col>
              </Row>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex align-item-center justify-content-center">
          <Button className="btn-cancel-style" onClick={close}>
            بستن
          </Button>
          <Button
            className="btn-success-style"
            onClick={() => setShowNewAddressModal(true)}
          >
            ثبت آدرس جدید
          </Button>
        </Modal.Footer>
      </Modal>

      {showNewAddressModal && (
        <NewAddress senderOrgetter={1} onClose={close} setResult={set} />
      )}
    </Fragment>
  );
}

export default GetterAddressModal;
